import React, { createContext, useEffect, useRef, useState } from 'react';
import randomString from '../utils/randomString';

//create a context for authentication
export const UserAuthContext = createContext();

export function UserAuthProvider({ children }) {
    const [isAuthenticated, setIsAuthenticated] = useState(function () {
        // Get initial state from local storage
        const savedValue = localStorage.getItem('user');
        return savedValue ? savedValue : '';
    });
    const firstRun = useRef(true);
    // const [user, setUser] = useState({});

    useEffect(() => {
        if (firstRun.current !== true) {
            // Save state to local storage whenever it changes
            localStorage.setItem('user', isAuthenticated);
        }
        firstRun.current = false;
    }, [isAuthenticated]);

    function login(userData) {
        localStorage.setItem('name', userData.name ? userData.name : '');
        localStorage.setItem('userId', userData.userId ? userData.userId : '');
        localStorage.setItem('token', userData.token ? userData.token : '');
        localStorage.setItem('expiry', userData.expiry ? userData.expiry : '');
        //generate a random string based the userId and put it here
        setIsAuthenticated(randomString(30));
        // setUser(userData);
    }

    const logout = () => {
        // setIsAuthenticated(false);
        // setUser(null);
        localStorage.removeItem('name');
        localStorage.removeItem('userId');
        localStorage.removeItem('token');
        localStorage.removeItem('expiry');
        setIsAuthenticated('');
        const currentPath = window.location.pathname;
        if (currentPath.includes('/orgid/')) {
            window.location.href = currentPath;
        } else window.location.href = '/';
    };
    return <UserAuthContext.Provider value={{ isAuthenticated, login, logout }}>{children}</UserAuthContext.Provider>;
}
